import { render } from "./GraduateStudentView.vue?vue&type=template&id=1bb3c406&scoped=true"
const script = {}

import "./GraduateStudentView.vue?vue&type=style&index=0&id=1bb3c406&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb3c406"]])

export default __exports__